<template>
  <div>
    <div
      class="banner_work_with_us"
      :style="{ backgroundImage: `url(${dataWWU.image_url})` }"
    >
   

      <div class="banner_content">
        <div class="width-full"></div>
        <div class="banner_text hide-text">
          <div class="header">{{ dataWWU.title }}</div>
          <div class="desc">{{ dataWWU.description }}</div>
          <div class="read-more">
            <img
              src="@/assets/icons/Button.svg"
              alt="button"
              style="width: 100%"
            />
            <a id="apply-wwu" :href="'/work-with-us'">Apply</a>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="banner_text banner-text-sm">
          <div class="header">{{ dataWWU.title }}</div>
          <div class="desc">{{ dataWWU.description }}</div>
         <BlobButton :shortBtn="true" text="Apply" @click="() => goToCareer()"/>
        </div>
    </div>
  </div>
  
</template>




<script>
import CustomButtonComponent from "@/components/CustomButtonComponent.vue";
import BlobButton from "@/components/ui/BlobButton.vue";
import titleMixin from "@/mixins/TitleMixins.js";
import axios from "axios";
import { useRouter } from "vue-router";

export default {
  name: "work-with-us",
  mixins: [titleMixin],
   components: {BlobButton},

  setup() {
    const router = useRouter();

    const goToCareer = () => {
      router.push('/work-with-us')
    }

    return {goToCareer}
  },

  data() {
    return {
      dataWWU: {},
    };
  },

  mounted() {
    let preview = this.$route.query.preview ? this.$route.query.preview : 0;
    axios.get("/careers/homepage?preview=" + preview).then((response) => {
      this.dataWWU = response.data.data;
    });
  },
};
</script>

<style scoped>
.banner_work_with_us {
  background: white url("@/assets/images/home/work_with_us.png") no-repeat
    left 0px;
  height: 800px;
  background-size: contain;
}

.width-full {
  width: '100%';
  height: auto;
}

.banner_content {
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* 3 equal columns */
  gap: 1rem; /* space between grid items */
  align-items: center;
}


.banner_text {
  height: 800px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0 50px;
  text-align: center;
}

.banner-text-sm {
  display: none;
}

.banner_text div {
  margin: 10px;
}

.banner_text .header {
  font-size: 4em;
  font-weight: bold;
  color: #db0007;
}

.banner_text .desc {
  font-weight: bold;
  font-size: 1.5em;
}

@media only screen and (max-width: 600px) {
  .banner_work_with_us {
    height: 250px;
    width: auto;
    background-size: contain;
    margin-top: 5%;
  }

  .banner_text {
    display: none;
    height: auto;
    width: '100%';
    align-items: center;
    justify-content: center;
    align-items: center;
  }

  .banner-text-sm {
    display: flex;
  }

  .banner_text .header {
    font-size: 1.6em;
    font-weight: bold;
    color: #db0007;
  }

  .desc {
    font-size: 1.1em !important;
    font-weight: 400 !important;
  }

  .banner_content {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

@media only screen and (min-width: 601px) and (max-width: 1024px) {
  .banner_work_with_us {
    height: 450px;
    width: auto;
    background-size: cover;
    display: flex;
    flex-direction: column;
    margin-top: 5vw;
  }

  .banner_text {
    display: none;
    height: auto;
    width: '100%';
    align-items: center;
    justify-content: center;
    align-items: center;
  }

  .banner-text-sm {
    display: flex;
  }

  .banner_text .header {
    font-size: 2em;
    font-weight: bold;
    color: #db0007;
  }

  .banner_text .desc {
    font-weight: bold;
  }
}

@media only screen and (min-width: 1200px) and (max-width: 1441px) {
  .banner_work_with_us {
    height: 600px;
    width: auto;
    background-size: contain;
  }
}

.read-more {
  position: relative;
  text-align: center;
  color: white;
  width: 270px;
  padding: 0 50px;
}

.banner_content a {
  position: absolute;
  top: 35%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-decoration: none;
  color: black;
  font-weight: bold;
}
</style>